module.exports = __webpack_public_path__ + "img/uid-token-login-popup-bg.1cda76e0.png";